// src/api/expert-activity.api.ts
import api from './Axios';

export interface ToggleAvailabilityPayload {
  isAvailableChat?: boolean;
  isAvailableCall?: boolean;
  isAvailableVideoCall?: boolean;
}

export const expertActivityApi = {
  // Get Current Database Toggles
  getAvailability: async () => {
    const response = await api.get('/api/expert-dashboard/availability');
    return response.data;
  },

  // Update Database Toggles
  toggleAvailability: async (data: ToggleAvailabilityPayload) => {
    const response = await api.patch('/api/expert-dashboard/availability/toggle', data);
    return response.data;
  }
};